<h2 mat-dialog-title>Modificar parámetros de la métrica</h2>
<div mat-dialog-content>
  <p class="context">{{ data.key_result_title }}</p>

  @if (is_locked) {
    <div class="lock-warning" role="alert">
      <mat-icon>warning</mat-icon>
      <span>
        No se pueden modificar los parámetros mientras el Key Result está en un periodo en curso. Podrás cambiarlos cuando el periodo aún no
        haya empezado.
      </span>
    </div>
  }

  <form [formGroup]="form" class="vc-form">
    <div class="row-thresholds">
      <mat-form-field appearance="fill">
        <mat-label>Valor óptimo</mat-label>
        <input matInput type="number" formControlName="good_value" />
        @if (unit_suffix()) {
          <span matSuffix class="unit-suffix">{{ unit_suffix() }}</span>
        }
      </mat-form-field>
      <mat-form-field appearance="fill">
        <mat-label>Valor aceptable</mat-label>
        <input matInput type="number" formControlName="acceptable_value" />
        @if (unit_suffix()) {
          <span matSuffix class="unit-suffix">{{ unit_suffix() }}</span>
        }
      </mat-form-field>
      <mat-form-field appearance="fill">
        <mat-label>Evaluación</mat-label>
        <mat-select formControlName="evaluation">
          @for (evaluation of evaluations; track evaluation.value) {
            <mat-option [value]="evaluation.value">{{ evaluation.label }}</mat-option>
          }
        </mat-select>
      </mat-form-field>
      <mat-form-field appearance="fill">
        <mat-label>Unidad</mat-label>
        <input matInput formControlName="unit" />
      </mat-form-field>
    </div>
  </form>
</div>
<div mat-dialog-actions align="end">
  <button mat-button type="button" (click)="close()">Cerrar</button>
  @if (!is_locked) {
    <button mat-flat-button color="primary" type="button" [disabled]="form.invalid || saving()" (click)="save()">Guardar</button>
  }
</div>
